import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { PaginatedMonitorErrors } from "@/types/ApiResponses/Monitor";

export interface MonitorErrorsParams {
  page: number;
  pageSize: number;
  status?: string[];
  source?: string[];
  search?: string;
  sort?: "last_seen" | "count";
}

// The axios instance's `paramsSerializer: { indexes: null }` turns array
// params into repeated keys (`status=open&status=resolved`), which the
// server's `stringOrArraySchema` accepts on both `status` and `source`.
export const getMonitorErrors = async (
  props: QueryProps<MonitorErrorsParams>
): Promise<PaginatedMonitorErrors> => {
  const res = await api.client.get("/monitor/errors", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
